import React, { useId } from 'react';

import Box from '../Box/Box';
import Text from '../Text/index';

import TSwitch from './@types/TSwitch';
import componentName from './name';
import Icon from '../Icon/Icon';
import InlineSwitch from './InlineSwitch';

const Switch = ({ bodyTitle, bodyDescription, iconName, id, ...rest }: TSwitch) => {
  const generatedId = useId();
  const a11yId = id ?? `${componentName}-${generatedId}`;

  const switchLabelId = `${a11yId}-label`;
  const switchDescriptionId = bodyDescription ? `${a11yId}-description` : undefined;
  const inputId = `${a11yId}-input`;

  return (
    <InlineSwitch
      {...rest}
      ariaLabelledBy={switchLabelId}
      ariaDescribedBy={switchDescriptionId}
      isCompound={true}
      inputId={inputId}
      id={id}
    >
      {iconName && (
        <Box as="div" parent={componentName} name="Icon">
          <Icon name={iconName} data-testid="Icon" />
        </Box>
      )}
      <Box as="div" parent={componentName} name="Body">
        <Text.BodyBase color="text-primary" id={switchLabelId}>
          {bodyTitle}
        </Text.BodyBase>
        {bodyDescription && (
          <span
            id={switchDescriptionId}
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
            onKeyDown={(e: React.KeyboardEvent) => e.stopPropagation()}
          >
            <Text.BodySmall color="text-primary">{bodyDescription}</Text.BodySmall>
          </span>
        )}
      </Box>
    </InlineSwitch>
  );
};

export default Switch;
